import { render, staticRenderFns } from "./table-assigment.vue?vue&type=template&id=134cfd45&"
import script from "./table-assigment.vue?vue&type=script&lang=js&"
export * from "./table-assigment.vue?vue&type=script&lang=js&"
import style0 from "./table-assigment.vue?vue&type=style&index=0&id=134cfd45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports